import { EnvironmentProviders, Provider } from '@angular/core';
import { provideSoftAppsModuleConfig } from '@softapps/core';
import { SOFTLINE_CONFIG_DEFINITION } from '@softline/dynamic/base';
import { ArchivbelegDownloadStrategy } from './commands/download/archiv-beleg-download.strategy';
import { BelegDownloadStrategy } from './commands/download/beleg-download.strategy';
import { DatentraegerDownloadStrategy } from './commands/download/datentraeger-download.strategy';
import { FremdbelegDownloadStrategy } from './commands/download/fremd-beleg-download.strategy';
import { default as businessCaseDefaultDefinition } from './definitions/business-case-list.definition.json';
import { default as listDefaultDefinition } from './definitions/gesamtabfrage-list.definition.json';
import { gesamtabfrageQueryDefinition } from './definitions/gesamtabfrage-query.definition';
import {
  SOFTLINE_DEFINITION_VOUCHER_BUSINESS_CASE,
  SOFTLINE_DEFINITION_VOUCHER_LIST,
  SOFTLINE_DEFINITION_VOUCHER_QUERY,
} from './gesamtabfrage.api';
import {
  GesamtabfrageConfig,
  SOFTLINE_CONFIG_GESAMTABFRAGE,
} from './gesamtabfrage.shared';

export function provideGesamtabfrageGlobals(
  config?: GesamtabfrageConfig
): Array<Provider | EnvironmentProviders> {
  return [
    BelegDownloadStrategy,
    FremdbelegDownloadStrategy,
    ArchivbelegDownloadStrategy,
    DatentraegerDownloadStrategy,
    {
      provide: SOFTLINE_CONFIG_GESAMTABFRAGE,
      useValue: { download: [BelegDownloadStrategy] },
    },
    provideSoftAppsModuleConfig('#GESAMTABFRAGE.TITLE', SOFTLINE_CONFIG_GESAMTABFRAGE),
    {
      provide: SOFTLINE_CONFIG_DEFINITION,
      useValue: {
        name: SOFTLINE_DEFINITION_VOUCHER_QUERY,
        definition: gesamtabfrageQueryDefinition,
      },
      multi: true,
    },
    {
      provide: SOFTLINE_CONFIG_DEFINITION,
      useValue: {
        name: SOFTLINE_DEFINITION_VOUCHER_LIST,
        definition: listDefaultDefinition,
      },
      multi: true,
    },
    {
      provide: SOFTLINE_CONFIG_DEFINITION,
      useValue: {
        name: SOFTLINE_DEFINITION_VOUCHER_BUSINESS_CASE,
        definition: businessCaseDefaultDefinition,
      },
      multi: true,
    },
    // Customer config overrides the default above (later multi-less provider wins).
    ...(config ? [{ provide: SOFTLINE_CONFIG_GESAMTABFRAGE, useValue: config }] : []),
  ];
}
